/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getPublicProjectHistoryActions, {
    getPublicProjectHistoryTypes,
} from '../../../redux/collectData/getPublicProjectHistory'
import { Get } from '../../../serveur/axios'

function* getPublicProjectHistorySagas() {
    try {
        const res = yield Get(`csv/project_data/historique_file`)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getPublicProjectHistoryActions.getPublicProjectHistorySuccess(
                        res.data.data
                    )
                ),
            ])
        } else {
            yield put(
                getPublicProjectHistoryActions.getPublicProjectHistoryFailure(
                    res
                )
            )
        }
    } catch (error) {
        yield put(
            getPublicProjectHistoryActions.getPublicProjectHistoryFailure(error)
        )
    }
}

export function* getPublicProjectHistorySaga() {
    yield takeLatest(
        getPublicProjectHistoryTypes.GET_PUBLIC_PROJECT_HISTORY_REQUEST,
        getPublicProjectHistorySagas
    )
}
